<template>
    

    <div>
      <div id="preloader" class="preloader-hide">
        <div class="spinner-border color-red-dark" role="status"></div>
      </div>
      <div
        class="locker-loader"
        :style="{ display: $store.state.loading ? 'block' : 'none' }"
      >
        <div class="locker-main" style="min-width: 140px">Түр хүлээнэ үү...</div>
      </div>
      <main-menu></main-menu>
      <detail-modal></detail-modal>
      <router-view />
      <p class="offline-message bg-red-dark color-white">
        No internet connection detected
      </p>
      <p class="online-message bg-green-dark color-white">You are back online</p>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  import mainMenu from "@/views/apps/ubtzyouth/mainMenu";
  import detailModal from "@/views/apps/ubtzyouth/detail";
  
  export default {
    components: {
      mainMenu,
      detailModal
    },
    mounted(){
      //console.log('ubtz youth mounted !!!');
      this.handlePages({store: this.$store});

      //document.getElementByClass('dynamic-app').addClass = "gradient-1";
      //let _obj = this.$store.state.app.mainLayoutConfig;
      //_obj.header = 201;
      //this.handleMainLayoutConfig(_obj);
    },
    methods: {
      ...mapActions(["handleLoading", "handleLogOut", "handleMainMenu", "handlePages", "handleMainLayoutConfig"]),
    },
  };
  </script>
  
  <style lang="less">
  .dynamic-app .locker-loader {
    display: none;
  }
  .dynamic-app.dynamic-locker .locker-loader {
    display: block;
  }
  .locker-loader {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: hsla(0, 0%, 100%, 0.5) !important;
    backdrop-filter: blur(1px);
    z-index: 9999;
    top: 0;
    left: 0;
    text-align: center;
  }
  .locker-main {
    color: white;
    border-radius: 0 0 5px 5px;
    padding: 5px;
    width: 10vw;
    margin: 0 auto;
    background: orange;
  }
  </style>
  